<template>

    <div class="text-sm">

        <div class="flex flex-row justify-between items-start gap-x-8">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-medium flex items-center gap-x-2">Unified Personals (Admin View)
                    <UpgradePlan v-if="!plan_unified_personals" />
                </div>

                <div class="text-sm mt-3">When enabled, admins get a dedicated menu item called Unified Personals to
                    browse all videos created by teammates in their Personal libraries — making it easier to manage and
                    support the team’s work
                </div>

            </div>

            <div class="flex flex-shrink">
                <toggle :checked="unified_personals_enabled && plan_unified_personals" @click.prevent.stop
                    :disabled="!plan_unified_personals" @update="toggleWatch"></toggle>
            </div>
        </div>

    </div>

</template>






<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan.vue'


export default {

    props: [],

    components: {
        Toggle,
        UpgradePlan
    },

    data() {
        return {
            plan_unified_personals: this.$page.props.plan_unified_personals,
            unified_personals_enabled: false,
            saving: false,
        }
    },

    created() {

        if (this.$page.props.user.current_team.metadata) {
            const metadata = JSON.parse(this.$page.props.user.current_team.metadata)
            if (metadata.unified_personals_enabled) {
                this.unified_personals_enabled = metadata.unified_personals_enabled
            }
        }
    },
    computed: {
    },
    mounted() {

    },
    methods: {

        toggleWatch: function () {
            if (!this.plan_unified_personals || this.saving) {
                return
            }
            this.unified_personals_enabled = !this.unified_personals_enabled
            this.updateMeta({
                meta: "unified_personals_enabled",
                value: this.unified_personals_enabled
            })
        },
        updateMeta: function (params) {
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                    this.EventBus.emit('settingChanged', {
                        key: "unified_personals_enabled",
                        value: this.unified_personals_enabled
                    });
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        }
    }

}

</script>
